import React from 'react';
import PropTypes from 'prop-types';

import { DropTarget } from 'react-dnd';
import GroupedColumnButton from './GroupedColumnButton';
import { _constants } from 'components/react-data-grid';

const { DragItemTypes } = _constants;

const propTypes = {
  isOver: PropTypes.bool.isRequired,
  connectDropTarget: PropTypes.func,
  canDrop: PropTypes.bool.isRequired,
  groupBy: PropTypes.array,
  noColumnsSelectedMessage: PropTypes.string,
  panelDescription: PropTypes.string,
  onColumnGroupDeleted: PropTypes.func,
};

const defaultProps = {
  noColumnsSelectedMessage: 'Drag a column header here to group by that column',
  panelDescription: 'Drag a column header here to group by that column',
};

const GroupedColumnsPanel = props => {
  const getPanelInstructionMessage = () => {
    let { groupBy } = props;
    return groupBy && groupBy.length > 0 ? props.panelDescription : props.noColumnsSelectedMessage;
  };

  const renderGroupedColumns = () => {
    return props.groupBy.map(c => {
      const groupedColumnButtonProps = {
        columnKey: typeof c === 'string' ? c : c.key,
        name: typeof c === 'string' ? c : c.name,
        onColumnGroupDeleted: props.onColumnGroupDeleted,
        key: typeof c === 'string' ? c : c.key,
      };
      return <GroupedColumnButton {...groupedColumnButtonProps} />;
    });
  };

  const renderOverlay = color => {
    return (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          zIndex: 1,
          opacity: 0.5,
          backgroundColor: color,
        }}
      />
    );
  };

  const { connectDropTarget, isOver, canDrop } = props;
  return connectDropTarget(
    <div
      style={{
        padding: '2px',
        position: 'relative',
        margin: '-10px',
        display: 'inline-block',
        border: '1px solid #eee',
      }}
    >
      {renderGroupedColumns()} <span>{getPanelInstructionMessage()}</span>
      {isOver && canDrop && renderOverlay('yellow')}
      {!isOver && canDrop && renderOverlay('#DBECFA')}
    </div>
  );
};

GroupedColumnsPanel.defaultProps = defaultProps;
GroupedColumnsPanel.propTypes = propTypes;

const columnTarget = {
  drop(props, monitor) {
    // Obtain the dragged item
    let item = monitor.getItem();
    if (typeof props.onColumnGroupAdded === 'function') {
      props.onColumnGroupAdded(item.key);
    }
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    draggedolumn: monitor.getItem(),
  };
}

export default DropTarget(DragItemTypes.Column, columnTarget, collect)(GroupedColumnsPanel);
